import { Component, OnInit } from '@angular/core';

import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';

import { UserService } from 'src/app/services/user.service';

import { WavesModule, SelectModule, ToastService } from 'ng-uikit-pro-standard';
import { TabHistoryItemBase } from 'devexpress-richedit/lib/core/model/history/items/paragraph-properties-history-items';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-responsive',
  templateUrl: './responsive.component.html',
  styleUrls: ['./responsive.component.scss']
})
export class ResponsiveComponent implements OnInit {

  constructor(private route: ActivatedRoute, public userService: UserService, private toast: ToastService, private router: Router, private translate:TranslateService) { }

  currentEmail: string;

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params.b){
        this.userService.activateUser(params.b).subscribe(result => {
          this.toast.success(this.translate.instant('msgAccSuccActived'));
        });
      }
    });
    this.currentEmail = localStorage.getItem('email');
  }

  onAcceptTerm(){
    this.userService.activateUser(this.currentEmail).subscribe(result => {
      this.router.navigateByUrl('/home');
    });
  }

  goLogin(){
    this.router.navigateByUrl('/login');
  }

}
